import { gql } from '@apollo/client'

export const CORE_BILLING_PRODUCT_FIELDS = gql`
  fragment CoreBillingProductFields on BillingProduct {
    id
    name
  }
`

export const CORE_BILLING_PRODUCT_PRICE_FIELDS = gql`
  fragment CoreBillingProductPricingFields on BillingProviderProductPricing {
    id
    price
    trialSegmentPrice
    currency
    currencySymbol
    percentSavings
  }
`

export const CORE_BILLING_PRODUCT_TEXT_FIELDS = gql`
  fragment CoreBillingProductTextFields on BillingProviderProductText {
    id
    language
    key
    value
    parameters
    isValueProp
    valuePropOrder
    enabled
  }
`

export const CORE_BILLING_PROVIDER_PRODUCT_TEXT_FIELDS = gql`
  fragment CoreBillingProviderProductFields on BillingProviderProduct {
    id
    sku
    termLength
    termType
    description
    trialLength
    trialTermType
    checkoutEnabled
    currentSubscriptionPlanMatchesProduct
    nextSubscriptionPlanMatchesProduct
    currentSubscriptionPlanMatchesProviderProduct
    nextSubscriptionPlanMatchesProviderProduct
    providerFirstSegmentId
    providerSecondSegmentId
    allowChangePlan
  }
`
